import { useTranslation } from 'react-i18next';

type PackingListNotesProps = Readonly<{
  notes: string | null | undefined;
}>;

export function PackingListNotes({ notes }: PackingListNotesProps) {
  const { t } = useTranslation('order');
  return (
    <div className="p-4 border-t border-gray-100">
      <label className="block text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">
        {t('order.packing_list.notes_label')}
      </label>
      <p className="rounded-lg border border-gray-200 bg-white p-3 text-sm text-gray-600">
        {notes && notes.length > 0
          ? notes
          : t('order.packing_list.notes_empty')}
      </p>
    </div>
  );
}
